import { Contact } from 'lucide-react';

import { EmptyState, EmptyStateCircles, EmptyStateContent, EmptyStateDescription, EmptyStateTitle } from '@/components/ui/empty-state';
import { FeaturedIcon } from '@/components/ui/featured-icon';

export default function EmptyPostsList() {
  return (
    <EmptyState>
      <EmptyStateCircles />
      <FeaturedIcon size={'lg'}>
        <Contact />
      </FeaturedIcon>
      <EmptyStateContent>
        <EmptyStateTitle>Brak Postów</EmptyStateTitle>
        <EmptyStateDescription>
          Żaden post nie został <br /> dotychczas utworzony na twojej stronie
        </EmptyStateDescription>
      </EmptyStateContent>
    </EmptyState>
  );
}
